/**
 * @class SharingTypes
 * @name types
 * @memberof Mojito.Services.Sharing
 */
export default class SharingTypes {}

/**
 * Type of share link action.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Services.Sharing.types
 */
SharingTypes.SHARE_LINK_TYPE = {
    COPY: 'COPY',
    SHARE: 'SHARE',
};
